'use client';
var classes = {"root":"m_96b553a6"};

export { classes as default };
//# sourceMappingURL=FloatingIndicator.module.css.mjs.map
